import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  VENDOR_REGISTER,
  VENDOR_REGISTER_SUCCESSFUL,
  VENDOR_REGISTER_FAILED,
} from "./actionTypes"

export const registerUser = user => {
  return {
    type: REGISTER_USER,
    payload: { user },
  }
}

export const registerUserSuccessful = user => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  }
}

export const registerUserFailed = user => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  }
}

export const vendorRegister = (user, navigate) => {
  return {
    type: VENDOR_REGISTER,
    payload: { user, navigate },
  }
}

export const vendorRegisterSuccessful = user => {
  return {
    type: VENDOR_REGISTER_SUCCESSFUL,
    payload: user,
  }
}

export const vendorRegisterFailed = error => {
  return {
    type: VENDOR_REGISTER_FAILED,
    payload: error,
  }
}
